// extracted by mini-css-extract-plugin
export default {"list":"Pa+Ln","align-end":"bdxXm","social":"i3l9q","simple-footer-copyright":"_8JaNA"};